import Vue from 'vue'
import BaseImg from '@/components/BaseImg'
import BaseBlock from '@/components/BaseBlock'
import Breadcrumb from '@/components/Breadcrumb'
import BaseSubRouteContainer from '@/components/BaseSubRouteContainer'
import AYearPicker from '@/components/AYearPicker'

Vue.component('base-img', BaseImg)
Vue.component('base-block', BaseBlock)
Vue.component('breadcrumb', Breadcrumb)
Vue.component('base-sub-route-container', BaseSubRouteContainer)
Vue.component('a-year-picker', AYearPicker)
